export const getPrimaryAddress = (addresses) => (addresses || []).find((address) => address.name === "Primary");
export const getPrimaryPhone = (phones) => (phones || []).find((phone) => phone.name === "Primary");
